import { render } from "./CodeVerification.vue?vue&type=template&id=4e9b8bb8&scoped=true"
import script from "./CodeVerification.vue?vue&type=script&lang=js"
export * from "./CodeVerification.vue?vue&type=script&lang=js"

import "./CodeVerification.vue?vue&type=style&index=0&id=4e9b8bb8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9b8bb8"]])

export default __exports__